module.exports = __webpack_public_path__ + "img/icon-suitcase.55b96eff.svg";